import React, { useCallback } from 'react'
import { Field } from 'formik';
import classnames from 'classnames';
import AnimateHeight from 'react-animate-height';
import { theme } from '../../../../../tailwind.config';
import { ArrowDownComponent } from 'ui/Icons';
import { useResponsive } from 'containers/CRM/hooks/useResponsive';
import { ECrmDirectoryEntryType } from 'services/CrmApi/types/DirectoryEntry';
import { ExistingDirectoryEntriesSimpleSearch } from '../ExistingDirectoryEntriesSearch/ExistingDirectoryEntriesSimpleSearch';

interface IAddContactExistingProps {
  isOpen: boolean;
  toggleOpen: (isOpen: boolean) => void;
  excludeId?: string;
}

export const AddContactExisting: React.FC<IAddContactExistingProps> = ({ isOpen, toggleOpen, excludeId }) => {
  const { isMobile, isTablet, isDesktop, isDesktopHD } = useResponsive();

  const sectionClassname = classnames(
    'section-title font-pt-sans text-[17px] leading-normal text-black m-0 select-none py-0 px-0',
    { 'font-[400]': !isOpen, 'font-[700]': isOpen }
  );
  const existingSearchClassname = classnames('form-container flex flex-col justify-between gap-[20px] mt-[20px]', {
    'w-full': isMobile,
    'w-[480px]': isDesktop || isDesktopHD || isTablet
  });

  const toggleSection = useCallback(() => {
    toggleOpen(!isOpen);
  }, [isOpen, toggleOpen]);

  return (
    <div className="px-[10px]">
      <div className="page-section-title font-pt-sans cursor-pointer flex justify-start items-center gap-[5px]" onClick={toggleSection}>
        <span className={classnames('flex justify-center items-center transform-transition transition-ease-in-out duration-300 cursor-pointer',
            { '-rotate-90': !isOpen, 'rotate-0': isOpen }
          )}
        >
          <ArrowDownComponent icon={theme.colors['black']} />
        </span>
        <p className={sectionClassname}>
          Select Existing
        </p>
      </div>
      <AnimateHeight duration={300} height={isOpen ? 'auto' : 0} className="accordion-area">
        <>
          <div className={existingSearchClassname}>
            <Field name="existingContactId">
              {({ field: { name, value }, form: { setFieldValue, setFieldTouched } }) => (
                <ExistingDirectoryEntriesSimpleSearch value={value} onChange={value => {
                  setFieldValue(name, value);
                  setFieldTouched(name, value);
                }} directoryEntryType={ECrmDirectoryEntryType.PERSON} excludeIds={excludeId ? [excludeId] : undefined} />
              )}
            </Field>
          </div>
        </>
      </AnimateHeight>
    </div>
  )
}